import RiseApiAdapter from 'rise-ui/adapters/apis/rise-api.js';

import ENV from 'rise-ui/config/environment.js';

/**
 * Base adapter for all ember-data requests to data-admin server
 */
export default class ContentApiAdapter extends RiseApiAdapter {
  host = ENV.APP.API.CONTENT.URL;
  namespace = ENV.APP.API.CONTENT.NAMESPACE;
  findRecord(store, type, id, snapshot, key = 'filter[id]') {
    return super.findRecord(store, type, id, snapshot, key);
  }
}
